import { twMerge } from "tailwind-merge";

export type Props = {
  className?: string;
  count: number;
  theme?: "light" | "dark";
};

export function CountBadge({ count, theme = "light", className }: Props) {
  if (count === 0) return null;

  return (
    <span
      className={twMerge(
        "absolute top-0 right-0 translate-x-1/3 -translate-y-1/3 bg-red-600 text-brand-50 rounded-full w-5 h-5 flex items-center justify-center",
        "text-[11px] font-medium",
        theme === "dark" && "bg-error-700",
        className
      )}
    >
      {count}
    </span>
  );
}

export default CountBadge;
